<template>
  <div class="container">
    <router-link to="/">
      <img class="footer-logo" src="@/assets/images/JAW-Innovation-Group-Logo.png" alt="An image of JAW Innovation Group logo">
    </router-link>

    <div class="footer-details">
      <router-link class="footer-link" to="/about">Privacy Policy</router-link>
      <router-link class="footer-link" to="/about">Mission</router-link>
      <router-link class="footer-link" to="/about">About Us</router-link>
      <router-link class="footer-link" to="/contact">Contact</router-link>
    </div>

    <div class="socials">
      <img class="social-icon" src="@/assets/instagram.svg" alt="Instagram social media link"/> 
      <img class="social-icon" src="@/assets/X.svg" alt="X social media link"/> 
      <img class="social-icon" src="@/assets/linkedin.svg" alt="Linkedin social media link"/> 
    </div>
  </div>

</template>

<script setup>

</script>

<style scoped>
.container {
  width: 100%;
  height: 356px;
  margin-top: 50px;
  background-color: #1D204E;
}

.footer-logo {
  width: 199px;
  height: 65px;
  margin-top: 35px;
  margin-bottom: 35px;
}

.footer-details {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer-link {
  margin-bottom: 5px;
  color: #00FF0C;
  font-size: 13px;
  font-family: Oxanium-SemiBold;
  text-decoration: none;
}

.socials {
  width: 131px;
  margin: 0 auto;
  margin-top: 45px;
  display: flex;
  justify-content: space-around;
  border: 1px;
}

@media (min-width: 640px) {

}

/* md: ≥ 768px - Tablets / landscape phones */
@media (min-width: 768px) {

}

/* lg: ≥ 1024px - Small laptops */
@media (min-width: 1024px) {
  .container {
    display: flex;
    align-items: center;
  }

  .footer-logo {
    width: 360px;
    height: 120px;
    margin-top: 105px;
    margin-bottom: 35px;
    margin-left: 50px;
    cursor: pointer;
  }

  .footer-details {
    width: 530px;
    margin-top: 50px;
    margin-left: 120px;
    display: flex;
    flex-direction: row;
  }

  .footer-link {
    margin-top: 20px;
    margin-right: 40px;
    font-size: 20px;
    text-decoration: none;
  }

  .socials {
    width: 300px;
    margin-top: 54px;
  }

  .social-icon {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: space-around;
  }
}

@media (min-width: 1280px) {

}

/* 2xl: ≥ 1536px - Large screens / 4K monitors */
@media (min-width: 1536px) {
  .container {
    display: flex;
  }

  .footer-logo {
    margin-left: 130px;
  }

  .footer-details {
    width: 620px;
    margin-left: 230px;
    display: flex;
  }

  .footer-link {
    margin-right: 60px;
    font-size: 20px;
    text-decoration: none;
  }

  .socials {
    width: 300px;
    margin: 0 auto;
    margin-top: 45px;
    display: flex;
    justify-content: space-around;
  }
}
</style>